import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useParams } from 'react-router-dom'
import { useAccessUser } from '@/hook/useAccessUser'
import { toast } from 'react-toastify'

import TextArea from '@components/shared/TextArea'
import { AssignToUser } from '@components/tract/AssignToUser'
import { UpsertRunsheet } from '@components/tract/UpsertRunsheet'
import { UpsertTract } from '@components/tract/UpsertTract'
import { ViewTractRunsheetsModal } from '@components/tract/ViewTractRunsheetsModal'
import { CheckedMultiSelect } from '@components/shared/CheckedMultiSelect'

import './Tracts.css'

export const TractView = () => {
    
    const { id } = useParams()
    
    const [showRunsheets, setShowRunsheets] = useState(false)
    const [createRunsheetDialogOpen, setCreateRunsheetDialogOpen] = useState(false)
    const [showEdit, showHideEdit] = useState(false)
    const [showAssignToUser, showHideAssignToUser] = useState(false)
    const [inFavoriteTracts, setInFavoriteTracts] = useState(true)
    const [favoriteTractId, setFavoriteTractId] = useState('')
    const [isAssigned, setIsAssigned] = useState(false)
    const [description, setDescription] = useState()
    const [selectValue, setSelectValue] = useState('')
    
    const [projectsDropdownOpen, setProjectsDropdownOpen] = useState(false)
    
    const favoriteTracts = useWireValue(store.favoriteTracts)
    const user = useWireValue(store.user)
    const tract = useWireValue(store.currentTract)
    const runsheets = useWireValue(store.runsheets)
    const projects = useWireValue(store.projects)
    
    // @todo wtf
    /* const favoriteTract = useMemo(
        () => ({
            tractId: tract?.id,
            userId: user?.id,
        }),
        [tract, user],
    ) */
    
    const addRunsheetToTrack = useAccessUser({ accessType: 'specific_collection', accessName: 'add_runsheet_to_tract' })
    const changeTract = useAccessUser({ accessType: 'additional', accessName: 'change_tract_runsheet_settings' })
    const assignUserTo = useAccessUser({
        accessType: 'additional',
        accessName: 'can_assign_a_user_to_a_tract_runsheet',
    })
    
    useEffect(() => {
        if (!user) return
        favoriteTracts?.forEach(favoriteTract => {
            if (favoriteTract.tractId && favoriteTract.userId) {
                if (favoriteTract.tractId === id && favoriteTract.userId === user.id) {
                    setFavoriteTractId(favoriteTract?.id)
                    setInFavoriteTracts(true)
                }
            }
        })
        !favoriteTractId && setInFavoriteTracts(false)
    }, [id, user, favoriteTractId, favoriteTracts])
    
    useEffect(() => {
        actions.fetchTract(id)
        actions.fetchRunsheetsByTractId(id)
        
        return () => {
            actions.emptyTract()
        }
    }, [id, isAssigned])
    
    useEffect(() => {
        actions.fetchProjects()
    }, [])
    
    useEffect(() => {
        setDescription(tract?.description ?? '')
    }, [tract])
    
    useEffect(() => {
        actions.fetchFavoriteTracts()
    }, [inFavoriteTracts])
    
    const onChange = projectList => {
        setIsAssigned(true)
        actions.updateTract(id, tract, {
            projects: projectList.map(({ value }) => value),
            abstracts: tract.abstracts && [tract?.abstracts[0].id],
        })
    }
    
    const handleChange = e => {
        const newStatus = e.target.value
        
        setSelectValue(newStatus)
        
        const updatedTract = {
            ...tract,
            status: newStatus,
        }
        
        actions.updateTract(id, updatedTract, {
            projects: tract.projects && tract.projects.map(({ id }) => id),
            abstracts: tract.abstracts && [tract?.abstracts[0].id],
        })
    }
    
    const addDeleteFavoriteTracts = () => {
        setInFavoriteTracts(!inFavoriteTracts)
        
        if (inFavoriteTracts) {
            actions.deleteFavoriteTract(favoriteTractId)
        } else {
            // actions.addFavoriteTract(favoriteTract)
            toast.warn('Not implemented yet')
        }
    }
    
    const projectsSort = (el, el2) => (el.name > el2.name ? 1 : -1)
    const projectsMap = project => ({ label: project.name, value: project.id })
    
    const selectProjectOptions = tract && projects?.sort(projectsSort).map(projectsMap)
    
    const selectProjectValues = tract?.projects
        ?.sort(projectsSort)
        ?.map(projectsMap)
    
    const toggleProjectsDropdownOpen = () => {
        setProjectsDropdownOpen(!projectsDropdownOpen)
    }
    
    if (!tract) return null
    
    return (
        
        <div>
            
            <div className="card table-responsive" style={{ overflowX: 'visible' }}>
                <table className="table table-sm table-nowrap card-table">
                    <thead>
                        <tr>
                            <th scope="col">Tract Name</th>
                            <th scope="col">Gross Acreage</th>
                            <th scope="col">Assigned To</th>
                            <th scope="col">Status</th>
                            <th scope="col">Status Date</th>
                            <th scope="col">Certification Date</th>
                            <th scope="col">Projects</th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{tract.name}</td>
                            <td>{tract.grossAcreage}</td>
                            <td>{`${
                                tract.assignedTo && tract.assignedTo[0]
                                    ? tract.assignedTo[0].firstName + ' ' + tract.assignedTo[0].lastName
                                    : ''
                            } `}</td>
                            <td className="pl-2">
                                <select
                                    className="text-center form-control form-control-sm"
                                    style={{ maxWidth: '80%' }}
                                    name="status"
                                    onChange={e => handleChange(e)}
                                    value={selectValue}>
                                    <option value="none" hidden>
                                        {`${tract.status}`}
                                    </option>
                                    <option value="in progress">In Progress</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </td>
                            <td>{tract.statusDate}</td>
                            <td>{tract.certDate}</td>
                            <td>
                                <div className="multiCheckboxDiv" style={{ position: 'relative' }}>
                                    <CheckedMultiSelect
                                        isOpen={projectsDropdownOpen}
                                        toggleOpen={toggleProjectsDropdownOpen}
                                        options={selectProjectOptions || []}
                                        placeholder="Search..."
                                        value={selectProjectValues || []}
                                        onChange={onChange}>
                                        <button
                                            className="flex items-center justify-between text-center
                                                CheckedMultiSelect-button form-control form-control-sm"
                                            onClick={toggleProjectsDropdownOpen}>
                                            <span>
                                                {selectProjectValues?.length
                                                    ? `${selectProjectValues.length} Projects`
                                                    : 'Select Projects'}
                                            </span>
                                            <span
                                                className="ml-2 fe fe-chevron-down"
                                                style={{ fontSize: '16px', fontWeight: 'bold' }} />
                                        </button>
                                    </CheckedMultiSelect>
                                </div>
                            </td>
                            <td className="align-middle">
                                <span
                                    className={`fe ${(inFavoriteTracts && 'fe-star-fill') || 'fe-star'} icon-mid`}
                                    onClick={addDeleteFavoriteTracts} />
                            </td>
                            <td>
                                {assignUserTo && (
                                    <button
                                        className="mr-2 btn btn-primary btn-md"
                                        onClick={() => {
                                            showHideAssignToUser(!showAssignToUser)
                                        }}>
                                        Assign
                                    </button>
                                )}
                                {changeTract && (
                                    <button
                                        className="btn btn-primary btn-md"
                                        onClick={() => {
                                            showHideEdit(!showEdit)
                                        }}>
                                        Tract Settings
                                    </button>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="form-group">
                <label htmlFor="inputDescription">Tract Description</label>
                <TextArea
                    id="inputDescription"
                    className="form-control"
                    value={description}
                    readOnly
                    name="description"
                    onChange={e => setDescription(e.target.value)} />
            </div>
            <div className="form-group">
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="inputDescription">Ownership Information</label>
                    </div>
                    <div className="col-md-9">
                        {runsheets.length !== 0 && addRunsheetToTrack && (
                            <span
                                className="mr-2 btn btn-primary btn-md"
                                onClick={() => {
                                    setShowRunsheets(true)
                                    setCreateRunsheetDialogOpen(false)
                                }}>
                                Runsheets
                            </span>
                        )}
                        {runsheets.length === 0 && (
                            <button
                                className="mr-2 btn btn-primary btn-md"
                                onClick={() => {
                                    setCreateRunsheetDialogOpen(true)
                                    setShowRunsheets(false)
                                }}
                                disabled={!addRunsheetToTrack}>
                                Add Runsheet
                            </button>
                        )}
                        <button className="mr-2 btn btn-primary btn-md">Title Breakdown</button>
                        <button className="mr-2 btn btn-primary btn-md">Audit Trail</button>
                    </div>
                </div>
            </div>
            <div className="card table-responsive">
                <table className="table table-sm table-nowrap card-table">
                    <thead>
                        <tr>
                            <th scope="col">Surface Owners</th>
                            <th scope="col">Percent Owned</th>
                            <th scope="col">Net Acreage</th>
                            <th scope="col">Lease Status</th>
                            <th scope="col">Encumbrances</th>
                            <th scope="col">Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="card table-responsive">
                <table className="table table-sm table-nowrap card-table">
                    <thead>
                        <tr>
                            <th scope="col">Mineral Owners</th>
                            <th scope="col">Executive</th>
                            <th scope="col">Bonus</th>
                            <th scope="col">Delay</th>
                            <th scope="col">Royalty</th>
                            <th scope="col">NMA</th>
                            <th scope="col">NRA</th>
                            <th scope="col">Lease Status</th>
                            <th scope="col">Lease Royalty</th>
                            <th scope="col">Encumbrances</th>
                            <th scope="col">Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="card table-responsive">
                <table className="table table-sm table-nowrap card-table">
                    <thead>
                        <tr>
                            <th scope="col">Working Interest Owners</th>
                            <th scope="col">Working Interest </th>
                            <th scope="col">NRI</th>
                            <th scope="col">Status</th>
                            <th scope="col">Encumbrances</th>
                            <th scope="col">Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="card">
                <table className="table table-sm table-nowrap card-table">
                    <thead>
                        <tr>
                            <th scope="col">Overriding Royalty Interest Owners</th>
                            <th scope="col">ORRI</th>
                            <th scope="col">Status</th>
                            <th scope="col">Encumbrances</th>
                            <th scope="col">Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {showAssignToUser && (
                <AssignToUser
                    showAdd={showAssignToUser}
                    showHideAdd={showHideAssignToUser}
                    selectedModelIds={tract.id ? [tract.id] : []}
                    assignedToIds={tract?.assignedTo?.map(({ id }) => id) || []}
                    which="Tract"
                    setIsAssigned={setIsAssigned} />
            )}
            {showEdit && (
                <UpsertTract
                    id="edit-tract"
                    showAdd={showEdit}
                    showHideAdd={showHideEdit}
                    editTract={tract}
                    setIsAddTract={() => {}} />
            )}
            
            {showRunsheets && (
                <ViewTractRunsheetsModal
                    show={showRunsheets}
                    showHide={setShowRunsheets}
                    showHideAddRunsheet={setCreateRunsheetDialogOpen}
                    tract={tract}
                    runsheets={runsheets} />
            )}
            
            {createRunsheetDialogOpen && (
                <UpsertRunsheet
                    showAdd={createRunsheetDialogOpen}
                    showHideAdd={setCreateRunsheetDialogOpen}
                    assignTract={tract}
                    redirect={false}
                    runsheetSaved={runsheet => {
                        if (runsheet) {
                            runsheets.push(runsheet)
                        }
                    }} />
            )}
        </div>
    )
}
